import axios, { AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios';
import * as ls from 'local-storage';

import Routes, { shouldImpersonate } from '@utils/routes';
import { localStorageKeys, SWITCH_USER_HEADER } from '@utils/constants';

const messages = {
  maintenanceMessage: 'Maintenance ongoing please try again later.',
  unauthorizedMessage: 'Your authentication has expired please log in again',
  userExistsMessage: 'An account with that email address already exists.',
};

const handleSuccess = (response: AxiosResponse) => response;

const handleError = (error: AxiosError) => {
  const modifiedError = error;
  /**
   * Catch if the response is a 503 and add a more user friendly error message. If on the login screen do not try to redirect to maintenance.
   */
  if (error?.response?.status === 503) {
    // eslint-disable-next-line no-param-reassign
    error.message = messages.maintenanceMessage;
    window.history.pushState(null, '', Routes.maintenance.path);
  }

  /**
   * Catch if the response is a 401 and add a more user friendly error message. Redirect to login screen to allow user to reauthenticate.
   */
  if (error?.response?.status === 401) {
    // eslint-disable-next-line no-param-reassign
    error.message = messages.unauthorizedMessage;
    window.history.pushState(null, '', Routes.login.path);
  }

  let errorMessage = error.message;
  if (error.response?.data?.message) {
    errorMessage = error.response.data.message;
  }
  modifiedError.message = errorMessage;

  return Promise.reject(modifiedError);
};
function addImpersonation(config: AxiosRequestConfig) {
  const impersonationIri = ls.get<string>(localStorageKeys.impersonationIri);
  if (impersonationIri?.length > 0 && shouldImpersonate(config.url)) {
    // eslint-disable-next-line no-param-reassign
    config.headers[SWITCH_USER_HEADER] = impersonationIri;
  }
  return config;
}
const axiosClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_EXTERNAL_API_ENTRYPOINT,
  withCredentials: true,
  headers: {
    // @ts-ignore
    common: {
      'accept-version': process.env.NEXT_PUBLIC_API_VERSION,
    },
  },
});
axiosClient.interceptors.response.use(handleSuccess, handleError);
axiosClient.interceptors.request.use(
  (config: AxiosRequestConfig) => addImpersonation(config),
  (error) => Promise.reject(error)
);

export default axiosClient;
